/* cSpell:disable */
import { FooterConfig } from '@tenants/types/tenant';
import {
  getSubDomainUrlWithPath,
  RootDomain,
} from 'constants/domains';
import { LOCALE_EXP_COMMERCIAL_PATHS } from 'types/locales';

export function createFooterConfig(rootDomain: RootDomain): FooterConfig {
  const footerConfig: FooterConfig = {
    footerColumns: {
      column1: [
        {
          label: {
            key: LOCALE_EXP_COMMERCIAL_PATHS.FOOTER_SERVICES_LABEL,
            defaultValue: 'Services',
          },
          link: '/our-services',
          isAnchor: false,
          target: '_blank',
        },
        {
          label: {
            key: LOCALE_EXP_COMMERCIAL_PATHS.FOOTER_FINDADVISOR_LABEL, // this is marketing intentional advisors = experts
            defaultValue: 'Find an Advisor',
          },
          link: '/experts',
          isAnchor: false,
          target: '_blank',
        },
        {
          label: {
            key: LOCALE_EXP_COMMERCIAL_PATHS.FOOTER_LISTINGS_LABEL,
            defaultValue: 'Listings',
          },
          link: '/listings',
          isAnchor: false,
          target: '_blank',
        },
        {
          label: {
            key: LOCALE_EXP_COMMERCIAL_PATHS.FOOTER_JOINEXP_LABEL,
            defaultValue: 'Join eXp',
          },
          link: '/become-an-advisor',
          isAnchor: false,
          target: '_blank',
        },
        {
          label: {
            key: LOCALE_EXP_COMMERCIAL_PATHS.FOOTER_CALENDAR_LABEL,
            defaultValue: 'Calendar',
          },
          link: '/calendar',
          isAnchor: false,
          target: '_blank',
        },
      ],
      column2: [
        {
          label: {
            key: LOCALE_EXP_COMMERCIAL_PATHS.FOOTER_ABOUT_LABEL,
            defaultValue: 'About Us',
          },
          link: '/about-us',
          target: '_blank',
        },
        {
          label: {
            key: LOCALE_EXP_COMMERCIAL_PATHS.FOOTER_CONTACT_LABEL,
            defaultValue: 'Contact Us',
          },
          link: '/contact-us',
          target: '_blank',
        },
        {
          label: {
            key: LOCALE_EXP_COMMERCIAL_PATHS.FOOTER_CAREERS_LABEL,
            defaultValue: 'Careers',
          },
          link: '/contact-us',
          target: '_blank',
        },
        {
          label: {
            key: LOCALE_EXP_COMMERCIAL_PATHS.FOOTER_EXPWORLDHOLDINGS_LABEL,
            defaultValue: 'eXp World Holdings',
          },
          link: 'https://expworldholdings.com',
          target: '_blank',
        },
      ],
      column3: [
        {
          label: {
            key: LOCALE_EXP_COMMERCIAL_PATHS.FOOTER_LEGAL_TERMSOFUSE_LABEL,
            defaultValue: 'Terms of Use',
          },
          link: 'https://expworldholdings.com/terms-of-service/?__hstc=67108337.5fc709ed5907117a560fb8dc49aacc7a.1752070954406.1762375661073.1762439623555.59&__hssc=67108337.3.1762439623555&__hsfp=1300199577',
          target: '_blank',
        },
        {
          label: {
            key: LOCALE_EXP_COMMERCIAL_PATHS.FOOTER_LEGAL_PRIVACYPOLICY_LABEL,
            defaultValue: 'Privacy Policy',
          },
          link: 'https://expworldholdings.com/privacy-policy/?__hstc=67108337.5fc709ed5907117a560fb8dc49%5B%E2%80%A6%5D23555.59&__hssc=67108337.3.1762439623555&__hsfp=1300199577',
          target: '_blank',
        },
        {
          label: {
            key: LOCALE_EXP_COMMERCIAL_PATHS.FOOTER_LEGAL_COOKIEPOLICY_LABEL,
            defaultValue: 'Cookie Policy',
          },
          link: 'https://expworldholdings.com/cookie-policy',
          target: '_blank',
        },
        {
          label: {
            key: LOCALE_EXP_COMMERCIAL_PATHS.FOOTER_LEGAL_DMCANOTICE_LABEL,
            defaultValue: 'DMCA Notice',
          },
          link: 'https://www.exprealty.com/dmca',
          target: '_blank',
        },
        {
          label: {
            key: LOCALE_EXP_COMMERCIAL_PATHS.FOOTER_LEGAL_PRIVACYRIGHTSREQUEST_LABEL,
            defaultValue: 'Privacy Rights Request',
          },
          link: 'https://submit-irm.trustarc.com/services/validation/e6d7516d-df9c-4404-bd9f-21a2f0d2a6a4/',
          target: '_blank',
        },
      ],
      bottom: [
        [
          {
            label: {
              key: LOCALE_EXP_COMMERCIAL_PATHS.FOOTER_DISCLOSURES_TEXASBROKERAGESERVICES_LABEL,
              defaultValue: 'Texas Real Estate Commission information about brokerage services',
            },
            link: 'https://drive.google.com/file/d/1yJocXPMScNhiVnen4gtbhGu5LY7skDgN/view?usp=sharing',
            isAnchor: true,
            target: '_blank',
          },
        ],
        [
          {
            label: {
              key: LOCALE_EXP_COMMERCIAL_PATHS.FOOTER_DISCLOSURES_TEXASCONSUMERPROTECTION_LABEL,
              defaultValue: 'Texas Real Estate Commission Consumer Protection Notice',
            },
            link: 'https://www.trec.texas.gov/sites/default/files/pdf-forms/CN%201-4-1_1.pdf',
            isAnchor: true,
            target: '_blank',
          },
        ],
        [
          {
            label: {
              key: LOCALE_EXP_COMMERCIAL_PATHS.FOOTER_DISCLOSURES_FAIRHOUSING_LABEL,
              defaultValue: 'eXp Realty® is committed to adhering to the guidelines of The New York State Fair Housing Regulations. To view The Fair Housing Notice',
            },
          },
          {
            label: {
              key: '',
              defaultValue: ' →',
            },
            link: 'https://dos.ny.gov/system/files/documents/2021/08/fairhousingnotice.pdf',
            target: '_blank',
          },
          {
            label: {
              key: LOCALE_EXP_COMMERCIAL_PATHS.FOOTER_DISCLOSURES_FAIRHOUSING_CLICKHERE,
              defaultValue: 'Please click here',
            },
            link: 'https://dos.ny.gov/fair-housing',
            isAnchor: true,
            target: '_blank',
          },
        ],
        [
          {
            label: {
              key: LOCALE_EXP_COMMERCIAL_PATHS.FOOTER_DISCLOSURES_STANDARDIZEDOPERATINGPROCEDURE_LABEL,
              defaultValue: '*Standardized Operating Procedure for Purchasers of Real Estate Pursuant to Real Property Law 442-H. To View',
            },
          },
          {
            label: {
              key: '',
              defaultValue: ' →',
            },
            link: 'https://drive.google.com/file/d/1o1iG6CO5hFgawNGJibmd34loBFJeIqqJ/view',
            target: '_blank',
          },
          {
            label: {
              key: LOCALE_EXP_COMMERCIAL_PATHS.FOOTER_DISCLOSURES_STANDARDIZEDOPERATINGPROCEDURE_CLICKHERE,
              defaultValue: 'Please click here',
            },
            link: 'https://drive.google.com/file/d/1o1iG6CO5hFgawNGJibmd34loBFJeIqqJ/view',
            isAnchor: true,
            target: '_blank',
          },
        ],
        [
          {
            label: {
              key: LOCALE_EXP_COMMERCIAL_PATHS.FOOTER_BROKERS_CALIFORNIA,
              defaultValue: 'eXp Realty of California, Inc. | CA DRE# 01878277 | Deborah Penny – Designated Broker',
            },
          },
        ],
        [
          {
            label: {
              key: LOCALE_EXP_COMMERCIAL_PATHS.FOOTER_BROKERS_SOUTHERNCALIFORNIA,
              defaultValue: 'eXp Realty of Southern California, Inc. | CA DRE# 02187306 | Gina Saad – Designated Broker',
            },
          },
        ],
        [
          {
            label: {
              key: LOCALE_EXP_COMMERCIAL_PATHS.FOOTER_BROKERS_GREATERLOSANGELES,
              defaultValue: 'eXp Realty of Greater Los Angeles, Inc. | CA DRE# 01828532 | Justin DeCesare – Designated Broker',
            },
          },
        ],
        [
          {
            label: {
              key: LOCALE_EXP_COMMERCIAL_PATHS.FOOTER_BROKERS_NORTHERNCALIFORNIA,
              defaultValue: 'eXp Realty of Northern California, Inc. | CA DRE# 01951343 | Ryan Rosas – Designated Broker',
            },
          },
        ],
        [
          {
            label: {
              key: LOCALE_EXP_COMMERCIAL_PATHS.FOOTER_RECAPTCHA_PROTECTED,
              defaultValue: 'This site is protected by reCAPTCHA and the Google',
            },
          },
          {
            label: {
              key: LOCALE_EXP_COMMERCIAL_PATHS.FOOTER_RECAPTCHA_PRIVACYPOLICY,
              defaultValue: 'Privacy Policy',
            },
            link: 'https://policies.google.com/privacy',
            target: '_blank',
            isAnchor: true,
          },
          {
            label: {
              key: LOCALE_EXP_COMMERCIAL_PATHS.FOOTER_RECAPTCHA_AND,
              defaultValue: ' and ',
            },
          },
          {
            label: {
              key: LOCALE_EXP_COMMERCIAL_PATHS.FOOTER_RECAPTCHA_TERMSOFSERVICE,
              defaultValue: 'Terms of Service',
            },
            link: 'https://policies.google.com/terms',
            target: '_blank',
            isAnchor: true,
          },
          {
            label: {
              key: LOCALE_EXP_COMMERCIAL_PATHS.FOOTER_RECAPTCHA_APPLY,
              defaultValue: 'apply',
            },
          },
        ],
      ],
      joinUsLink: getSubDomainUrlWithPath(rootDomain, 'www', '/become-an-advisor'),
      footerImageData: {
        src: '',
        alt: {
          key: '',
          defaultValue: '',
        },
      },
    },
    showAccessibilityLink: false,
  };

  return footerConfig;
}